import {
  PriorAuthorizationControllerApi,
  UpdatePriorAuthorizationDocumentFormatEnum,
} from "../../../../services";
import {
  getConfigObject,
  useMutationWithLoading,
} from "../../../../utils/utils";

type Authorization = {
  priorAuthorizationId: string;
  authorizationNumber?: string;
  startDate?: string;
  endDate?: string;
  allowedVisit?: number;
  warningCount?: number;
  remainingVisit?: number;
  notes?: string;
  documentFormat?: UpdatePriorAuthorizationDocumentFormatEnum;
  cptCodes?: Array<string>;
  payers?: Array<string>;
  patientId?: string;
  providerId?: string;
  encounterId?: string;
  fileName?: string;
  requestingProviderId?: string;
  attachments?: File;
};

type AuthorizationUpdateParams = {
  authorization: Authorization;
  xTENANTID?: string;
};

/**
 * @author Rajkumar Rathod
 */
export const useAuthorizationUpdate = () =>
  useMutationWithLoading((params: AuthorizationUpdateParams) =>
    new PriorAuthorizationControllerApi(
      getConfigObject()
    ).updatePriorAuthorization(
      params.authorization.priorAuthorizationId,
      params?.authorization?.authorizationNumber,
      undefined, // dateOfRequest
      undefined, // dateOfApproval
      undefined, // dateOfExpiration
      undefined, // serviceType
      undefined, // authorizationStatus — derived by the backend from endDate
      params?.authorization?.notes,
      params?.authorization?.documentFormat,
      undefined, // icdCodes
      params?.authorization?.cptCodes,
      params?.authorization?.payers,
      params?.authorization?.patientId,
      params?.authorization?.providerId,
      params?.authorization?.encounterId,
      params?.authorization?.fileName,
      undefined, // noOfUnit
      undefined, // placeOfService
      params?.authorization?.requestingProviderId,
      params?.authorization?.startDate,
      params?.authorization?.endDate,
      params?.authorization?.allowedVisit,
      params?.authorization?.warningCount,
      params?.authorization?.remainingVisit,
      params?.xTENANTID,
      params?.authorization?.attachments
    )
  );
